// extracted by mini-css-extract-plugin
module.exports = {"sun":"sun_sun__3x5iN","background":"sun_background__1CHC2"};